import React from "react";
import { Mail, Phone } from "lucide-react";
import { NAV_LINKS, CONTACT_EMAIL, CONTACT_PHONE, CONTACT_PHONE_HREF, SERVICE_AREA, IMAGES } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-ls border-t py-14" style={{ borderColor: "var(--ls-border)" }}>
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-[1.5fr_1fr_1fr] gap-10">
          <div>
            <a href="#top" className="inline-flex">
              <img src={IMAGES.logo} alt="LightSpeed ROI" className="h-20 w-auto object-contain" />
            </a>
            <p className="mt-4 text-[#b7ab9b] max-w-sm leading-relaxed">
              Booked jobs for home service pros. Website built for free. $597/mo. Cancel anytime.
            </p>
          </div>

          <div>
            <h4 className="font-cond font-bold uppercase tracking-[0.14em] text-white text-sm mb-4">Explore</h4>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-[#b7ab9b] hover:text-orange transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-cond font-bold uppercase tracking-[0.14em] text-white text-sm mb-4">Where we work</h4>
            <p className="text-[#b7ab9b] leading-relaxed text-sm">{SERVICE_AREA}</p>
            <a
              href={CONTACT_PHONE_HREF}
              className="inline-flex items-center gap-2 mt-4 text-orange hover:text-white transition-colors font-bold text-lg"
            >
              <Phone className="w-4 h-4" /> {CONTACT_PHONE}
            </a>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="flex items-center gap-2 mt-2 text-[#b7ab9b] hover:text-orange transition-colors font-medium"
            >
              <Mail className="w-4 h-4" /> {CONTACT_EMAIL}
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t flex flex-col sm:flex-row items-center justify-between gap-3" style={{ borderColor: "var(--ls-border)" }}>
          <p className="text-[#9a8f80] text-sm">© {new Date().getFullYear()} LightSpeed ROI. All rights reserved.</p>
          <p className="text-[#9a8f80] text-sm font-cond tracking-wide">Home services only.</p>
        </div>
      </div>
    </footer>
  );
}
